import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProviders } from './providers.js';
import { AppLayout } from '@/components/layout/AppLayout.js';
import {
  AuthenticatedRoute,
  GuestOnlyRoute,
  PermissionProtectedRoute,
  ProjectAccessRoute,
} from '@/components/auth/RouteGuards.js';
import { useAuthStore } from '@/stores/useAuthStore.js';
import { appRoutes } from '@/config/appRoutes.js';
import { LoginPage } from '@/pages/LoginPage/LoginPage.js';

const AuthInitializer = ({ children }: { children: React.ReactNode }) => {
  const initializeAuth = useAuthStore((s) => s.initializeAuth);
  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);
  return <>{children}</>;
};

const AppRoutes = () => (
  <Routes>
    <Route
      path="/login"
      element={
        <GuestOnlyRoute>
          <LoginPage />
        </GuestOnlyRoute>
      }
    />
    <Route
      path="/"
      element={
        <AuthenticatedRoute>
          <AppLayout />
        </AuthenticatedRoute>
      }
    >
      <Route index element={<Navigate to="/dashboard" replace />} />
      {appRoutes.map((route) => {
        const element = route.requiredPermission ? (
          <PermissionProtectedRoute permission={route.requiredPermission}>
            <route.component />
          </PermissionProtectedRoute>
        ) : route.requiresProject ? (
          <ProjectAccessRoute>
            <route.component />
          </ProjectAccessRoute>
        ) : (
          <route.component />
        );
        return <Route key={route.path} path={route.path.slice(1)} element={element} />;
      })}
    </Route>
  </Routes>
);

export const App = () => (
  <AppProviders>
    <BrowserRouter>
      <AuthInitializer>
        <AppRoutes />
      </AuthInitializer>
    </BrowserRouter>
  </AppProviders>
);
